/* istanbul ignore file */
import { mainApi } from "config";
import { getClientFor } from "infrastructure/http";
import { ILocale, ILocalizable, commonMessages } from "infrastructure/localization";
import { displayMessages } from "ui/screens/translation-managers/translation-managers.localization";
import { ITenant, IEnterprise, IIndustry } from "ui/shared/models/common";

import { ITranslationMessageRequest, ITranslationMessagesGetRequest, ITranslationsObsoleteRequest } from "./TranslationMessages.api.types";
import { ITranslationMessageItem } from "./TranslationMessages.state";

const getApiProvider = () => {
  return {
    getIndustries: async (filter?: string) => {
      const response = await getClientFor(mainApi.name).get<IIndustry[]>("/industries", { params: filter });
      return response.data;
    },
    getTenants: async (enterpriseId?: string, filter?: string) => {
      const response = await getClientFor(mainApi.name).get<ITenant[]>("/tenants", {
        params: {
          filter: filter,
          enterpriseId: enterpriseId
        }
      });
      return response.data;
    },
    getEnterprises: async (filter?: string) => {
      const response = await getClientFor(mainApi.name).get<IEnterprise[]>("/enterprises", { params: filter });
      return response.data;
    },
    getLocales: async (filter?: string) => {
      const response = await getClientFor(mainApi.name).get<ILocale[]>("/locales", { params: filter });
      return response.data;
    },
    getTranslatedBy: () => {
      const translatedBy: ILocalizable[] = [
        { messageId: displayMessages.option("translatedByTenant") },
        { messageId: displayMessages.option("translatedByPlex") },
        { messageId: displayMessages.option("translatedByBoth") },
        { messageId: displayMessages.option("notTranslated") }
      ];
      return translatedBy;
    },
    getParentOptions: () => {
      const parentOptions: ILocalizable[] = [{ messageId: commonMessages.option("yes") }, { messageId: commonMessages.option("no") }];

      return parentOptions;
    },
    getTranslationMessages: async (parameters: ITranslationMessagesGetRequest) => {
      const params = {
        locale: parameters.locale,
        industry: parameters.industry,
        tenantId: parameters.tenant,
        enterpriseId: parameters.enterprise,
        text: parameters.text,
        messageId: parameters.messageId,
        translatedBy: parameters.translatedBy,
        parent: parameters.parent
      };

      const response = await getClientFor(mainApi.name).get<ITranslationMessageItem[]>("/messages/translations/search", { params });
      return response.data;
    },

    saveTranslations: async (translations: ITranslationMessageRequest[]) => {
      const response = await getClientFor(mainApi.name).post("/messages/translations", translations);
      return response.data;
    },

    exportTranslationsToXml: async (parameters: ITranslationMessagesGetRequest) => {
      const params = {
        locale: parameters.locale,
        tenantId: parameters.tenant,
        enterpriseId: parameters.enterprise,
        industry: parameters.industry,
        text: parameters.text,
        messageId: parameters.messageId,
        translatedBy: parameters.translatedBy,
        parent: parameters.parent
      };

      await getClientFor(mainApi.name).get("/messages/translations/export", { params, responseType: "blob" });
    },

    obsoleteTenantTranslations: async (request: ITranslationsObsoleteRequest) => {
      const response = await getClientFor(mainApi.name).delete(`messages/translations/locales/${request.locale}/tenants/${request.tenant}`, { data: request.translations });
      return response.data;
    },

    obsoleteEnterpriseTranslations: async (request: ITranslationsObsoleteRequest) => {
      const response = await getClientFor(mainApi.name).delete(`messages/translations/locales/${request.locale}/enterprises/${request.enterprise}`, { data: request.translations });
      return response.data;
    },

    downloadXmlTemplate: async () => await getClientFor(mainApi.name).get("/messages/translations/template", { responseType: "blob" })
  };
};

export const translationMessagesManagerApi = getApiProvider();
